export interface IAddItemOptions {
  force?: boolean;
  history?: boolean;
  update?: boolean;
}

export const AddItemDefaultOptions: IAddItemOptions = {
  force: false,
  history: true,
  update: true
} as const;
